



























































import Vue from 'vue'
import {
  ProductionPlanProcessServiceProxy,
  ProductionOrderServiceProxy,
  ProductionOrderDTO,
  SimpleWorkstationDTO,
  OrderProcessDTO,
  ProductionPlanProcessBO,
  OrderProcessWorkStationBO,
  ProductionOrderWorkStationDTO,
  WorkStationInfoDTO,
  ProductionOrderProcessServiceProxy,
} from '@/service-proxies/app-v2/coproduction.service-proxies'
import { WorkStationServiceProxy, WorkStationDTO, WorkStationGroupServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import { DataTreeNode } from '@/utils/array'
import _, { cloneDeep } from 'lodash'
import dayjs from 'dayjs'
const productionPlanProcessService = new ProductionPlanProcessServiceProxy()
const productionOrder = new ProductionOrderServiceProxy()
const workStation = new WorkStationServiceProxy()
const workStationGroup = new WorkStationGroupServiceProxy()
const crsp = new CodeRuleServiceProxy()
const popsp = new ProductionOrderProcessServiceProxy()
const columns = [
  {
    title: 'page_plan_craft_Sequence',
    dataIndex: 'processSequence',
  },
  {
    title: 'page_plan_craft_sort',
    dataIndex: 'sort',
  },
  {
    title: 'page_plan_craft_name',
    dataIndex: 'name',
  },
  {
    title: 'page_process_code',
    dataIndex: 'code',
  },
  {
    title: 'page_plan_assign_station',
    dataIndex: 'simpleWorkstationDTOList',
    width: 380,
    scopedSlots: { customRender: 'simpleWorkstationDTOList' },
  },
]
const calendarColumns = [
  {
    title: 'page_plan_production_plan_no',
    dataIndex: 'planCode',
    width: 140,
  },
  {
    title: 'page_product_name',
    dataIndex: 'productName',
  },
  {
    title: 'page_plan_order_no',
    dataIndex: 'orderCode',
  },
  {
    title: 'page_plan_craft_name',
    dataIndex: 'processName',
    width: 90,
  },
  {
    title: 'page_plan_process_production_personnel',
    dataIndex: 'producerName',
    width: 75,
  },
  {
    title: 'page_plan_wait_report_num',
    dataIndex: 'unReportNum',
    customRender: (text) => text || 0,
    width: 90,
  },
  {
    title: 'page_plan_process_total_assigned',
    dataIndex: 'totalNum',
    customRender: (text) => text || 0,
    width: 75,
  },
  {
    title: 'page_process_predict_endtime',
    dataIndex: 'planEndTime',
    width: 145,
    customRender: (time) => dayjs(time).format('YYYY-MM-DD HH:mm:ss'),
  },
]
export default Vue.extend({
  data() {
    return {
      data: [],
      confirmLoading: false,
      distribute: 0,
      orderCode: '',
      loading: false,
      workStationList: [],
      unassignedNum: 0,
      editData: {},
      workStationTreeData: [],
      orderList: [],
      showDisabled: false,
      codeRuleId: '',
      visible: false,
      calendarData: [],
      calendarLoading: false,
      title: '',
    }
  },
  props: {
    selectRows: {
      type: Object,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    columns() {
      return columns.map((item: any) => {
        return {
          ...item,
          title: this.$t(item.title),
        }
      })
    },
    calendarColumns() {
      return calendarColumns.map((item: any) => {
        return {
          ...item,
          title: this.$t(item.title),
        }
      })
    },
  },
  watch: {
    selectRows: {
      handler() {
        this.workStationList = []
        this.getWokstationGroup()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getCodeRules()
  },
  methods: {
    treeValue(txt, record) {
      const ids = []
      for (let i = 0; i < txt.length; i++) {
        const stationId = txt[i].workStationId
        const bee = this.workStationList.find((item) => item.id === stationId)
        if (bee !== undefined) {
          ids.push(bee.id + '-' + bee.parentId)
        }
      }
      return ids
    },
    async getCodeRules() {
      const res = await crsp.list('OrderObject')
      this.orderList = res
    },
    getList() {
      this.data = []
      this.unassignedNum = this.selectRows.unassignedNum ? this.selectRows.unassignedNum : 0
      if (this.modal == 1) {
        this.distribute = this.unassignedNum
      }
      productionPlanProcessService.getProductionProcessList(this.selectRows.id).then((res) => {
        if (res) {
          this.data = this.addWorkstationName(res)
        }
      })
    },
    getEditList() {
      this.data = []
      this.unassignedNum = this.selectRows.unassignedNum ? this.selectRows.unassignedNum : 0
      this.distribute = this.selectRows.unassignedNum ? this.selectRows.unassignedNum : 0
      this.orderCode = this.selectRows.code ? this.selectRows.code : ''
      productionOrder.getOrderProcessInfoList(this.selectRows.id).then((res) => {
        if (res) {
          this.editData = res
          this.data = this.addEditWorkstation(res.list)
        }
      })
    },
    getWokstationGroup() {
      this.workStationTreeData = []
      workStationGroup.allWorkStationGroupList().then((res) => {
        if (res) {
          const data: any = res.reduce((total, value) => {
            const key = value.id + '-' + value.parentId
            const newObj: any = _.cloneDeep(value)
            if (!newObj.isGroup) {
              newObj.name = newObj.title
            }
            total.push({
              ...newObj,
              // title: value.title,
              scopedSlots: {
                title: 'name',
              },
              value: key,
              key: key,
              // disabled: value.isGroup ? true : false
            })
            return total
          }, [])
          this.workStationTreeData = DataTreeNode.arrayToTree(data)
          this.workStationList = res
          if (this.selectRows.id && !this.edit) {
            this.getList()
          } else {
            this.getEditList()
          }
        }
      })
    },
    addWorkstationName(value: ProductionPlanProcessBO[]) {
      const data = []
      value.forEach((res) => {
        const value = {
          code: res.code,
          name: res.name,
          programName: res.programName,
          sort: res.sort,
          processSequence: res.processSequence || '',
          standardTime: res.standardTime,
          extend1: res.extend1,
          extend2: res.extend2,
          extend3: res.extend3,
          extend4: res.extend4,
          extend5: res.extend5,
          transportTime: res.transportTime,
          prepareTime: res.prepareTime,
          disassemblyTime: res.disassemblyTime,
          simpleWorkstationDTOList: [],
        }
        if (this.modal == 1) {
          value.simpleWorkstationDTOList = res.processWorkStationBOList
        }
        data.push(value)
      })
      return data
    },
    Workstation(value) {
      const data = []
      if (value.length > 0) {
        value.forEach((item) => {
          data.push(item.workStationId)
        })
      }
      return data
    },
    addEditWorkstation(value: OrderProcessWorkStationBO[]) {
      const data = []
      value.forEach((res) => {
        const value = {
          code: res.processCode,
          name: res.processName,
          processSequence: res.processSequence || '',
          sort: res.sort,
          id: res.processId,
          simpleWorkstationDTOList: res.workStationInfoDTO,
          workStationDTOList: this.Workstation(res.workStationInfoDTO),
        }
        data.push(value)
      })
      return data
    },
    handleOk() {
      if (!this.edit) {
        this.Ok()
      } else {
        this.save()
      }
    },
    Ok() {
      let planId = undefined
      let code = ''
      if (this.selectRows.id) {
        planId = this.selectRows.id
        code = this.selectRows.code
      } else {
        this.$message.warning(this.$t('page_plan_choose_plan_no'))
        return
      }
      if (this.distribute === 0 || this.distribute == null) {
        this.$message.warning(this.$t('page_plan_please_assign_num'))
        return
      }
      let hasWorkstation = 0
      this.data.forEach((res) => {
        if (res.simpleWorkstationDTOList && res.simpleWorkstationDTOList.length > 0) {
          hasWorkstation += 1
        }
      })
      if (hasWorkstation != this.data.length) {
        this.$message.warning(this.$t('page_plan_please_assign_station'))
        return
      }
      const orderDTO = {
        assignNum: this.distribute,
        orderCode: this.orderCode,
        orderProcessDTOList: this.data,
        codeRuleId: this.codeRuleId,
        planCode: code,
      } as ProductionOrderDTO

      this.confirmLoading = true
      productionOrder
        .assignPlan(planId, orderDTO)
        .then(() => {
          this.confirmLoading = false
          this.distribute = 0
          this.orderCode = ''
          this.unassignedNum = 0
          this.$emit('close', true)
          this.$message.success(this.$t('save_success'))
        })
        .catch(() => {
          this.confirmLoading = false
        })
    },
    save() {
      let planId = undefined
      if (this.selectRows.id) {
        planId = this.selectRows.id
      } else {
        this.$message.warning(this.$t('page_plan_choose_plan_no'))
        return
      }
      let hasWorkstation = 0
      this.data.forEach((res) => {
        if (res.simpleWorkstationDTOList && res.simpleWorkstationDTOList.length > 0) {
          hasWorkstation += 1
        }
      })
      if (hasWorkstation != this.data.length) {
        this.$message.warning(this.$t('page_plan_please_assign_station'))
        return
      }
      const data = {
        orderId: this.editData.id,
        processWorkStationDTOS: this.resoultData(),
      } as ProductionOrderWorkStationDTO
      productionOrder
        .updateOrderWorkStation(data)
        .then(() => {
          this.confirmLoading = false
          this.distribute = 0
          this.orderCode = ''
          this.unassignedNum = 0
          this.$emit('close', true)
          this.$message.success(this.$t('save_success'))
        })
        .catch(() => {
          this.confirmLoading = false
        })
    },
    resoultData() {
      const value = []
      this.data.forEach((res) => {
        const data = this.editData.list.find((item) => item.processId == res.id)
        const ProcessWorkStationDTO = {
          newWorkStationInfo: res.simpleWorkstationDTOList,
          oldWorkStationInfo: data.workStationInfoDTO,
          prcessId: res.id,
        }
        value.push(ProcessWorkStationDTO)
      })
      return value
    },
    handleCancel() {
      this.distribute = 0
      this.orderCode = ''
      this.showDisabled = false
      this.$emit('close', false)
    },
    distributeChange(value) {
      this.distribute = value
    },
    orderCodeChange(value) {
      this.orderCode = value.target.value
    },
    handleChangeSelect(val) {
      this.codeRuleId = val
      if (val) {
        this.showDisabled = true
        this.orderCode = ''
      } else {
        this.showDisabled = false
      }
    },
    handleChange(value, key, column) {
      const data = this.setWorkStationList(value)
      const newData = [...this.data]
      const target = newData.find((item) => key === item.sort)
      if (target) {
        target[column] = data
        this.data = newData
      }
    },
    setWorkStationList(value) {
      const List = []
      const recheckKeys = []
      this.workStationList.map((res) => {
        if (value.includes(this.addKeyId(res)) && !recheckKeys.includes(res.id) && !res.isGroup) {
          recheckKeys.push(res.id)
          const data = {
            workStationId: res.id,
            workStationName: res.title,
          }
          List.push(data)
        }
      })
      return List
    },
    addKeyId(item) {
      const key = item.id + '-' + item.parentId
      return key
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    openCalendar(e, item) {
      e.stopPropagation()
      if (item) {
        const params: any = {
          typeId: this.$route.path[this.$route.path.length - 1],
          workStationId: item.id,
        }
        this.title = '生产日历---'
        this.title = this.title + item.name
        setTimeout(() => {
          this.calendarData = []
          this.calendarLoading = true
          this.visible = true
          popsp
            .getWorkstationDetailByWorkStationId(params)
            .then((res) => {
              this.calendarData = res
              this.calendarLoading = false
            })
            .catch(() => {
              this.calendarLoading = false
            })
        }, 300)
      }
    },
    closeCalendar() {
      this.visible = false
      this.calendarData = []
    },
  },
})
